import type { User } from "../types/User";
import { http } from "./http";
import { isHttpError } from "./is-http-error";

export const getAuthenticatedUser = async () => {
  try {
    const response = await http.get("v4/users/me").json<User>();

    return response;
  } catch (error) {
    await http.mainRequestErrorHandler({ error });

    if (isHttpError(error)) {
      const errorJSON = await error.response.json<Error>();

      throw new Error(errorJSON.message);
    }

    throw error;
  }
};
